import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { TranslationContext } from '../../contexts/TranslationContext';
import { IUserSolution } from '../../services/WebApiClient';


export function ReceiptModal(props: {
    userSolution: IUserSolution;
    onClose: () => void;
}) {

    const tc = useContext(TranslationContext);

    return (
        <Modal onHide={props.onClose}
            animation={false}
            show
            centered
            scrollable
            size="sm"
        >
            <Modal.Header>
                {tc.translator("order receipt title", "Bekræftelse")}
            </Modal.Header>

            <Modal.Body>
                <div style={{ whiteSpace: "pre-line" }}>
                    {tc.translator("order receipt text",
                        "Tilbuddet er oprettet med tilbudsnummer {orderNumber}.\n\nOBS: Dette er IKKE en ordre endnu - indsend tilbudsnummeret til ordrekontoret.",
                        { orderNumber: props.userSolution.orderNumber ?? " -- " }
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <a className="btn btn-primary"
                    href={props.userSolution.pdfPath}
                    download={props.userSolution.name + ".pdf"}
                >
                    {tc.translator(
                        "save success modal download button",
                        "Hent løsning som .pdf"
                    )}
                </a>
                <button onClick={props.onClose} className="btn btn-primary">
                    {tc.translator("order receipt button close", "Luk")}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
